// extracted by mini-css-extract-plugin
module.exports = {"Scoreboard":"Scoreboard_Scoreboard__3qATf","Hidden":"Scoreboard_Hidden__aQwcK"};